import React from 'react'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import {auth} from '../../firebase/firebaseConfig'
import { useLocation } from 'react-router-dom';
import './Navbar.scss';


const Navbar = ({aboutVisible,portVisible,contactVisible}) => {
  const [hamToggled,setHamToggled] = React.useState(false);
  const currentUser = useSelector(state => state.user.currentUser)
  const logOut = async () =>  await signOut(auth);
  const location = useLocation();
  return (
        <div className={`nav-container ${hamToggled ? "navToggled":""}`}>
          <div className="logo">
            <a href="/">
                <img src="./sb.svg" alt="smart brain" />
            </a>
            <p className={`${currentUser ? "userName":"hide"}`}>{currentUser?.displayName}</p>
          </div>
           
          <nav className="navbar">
          <button onClick={() => setHamToggled(!hamToggled)} className= {`ham-btn ${hamToggled ? 'isActive':''}`}>
             
              <span></span>
                <span></span>
                  <span></span>
            </button>
            <ul className="navlist">
                { !currentUser ? <> <li className="nav-item">
                    <Link to="/register" className={`nav-link ${location.pathname === "/register" ? "active":""}`}>Register</Link>
                </li>
                <li className="nav-item">
                    <Link to="/login" className={`nav-link ${location.pathname === "/login" ? "active":""}  `}>Login</Link>
                </li></> :
                 <li className="nav-item">
                  <Link onClick={logOut}  className={`nav-link  `}>Sign Out</Link>
                  </li>}
              
            </ul>
            
          </nav>
        </div>
  )
}

export default Navbar